import React, {Component} from 'react';
import './css/App.css';
import AppNavbar from './Sidebar';
import Header from './Header';
import Dashboard from './Dashboard'


class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showComponent : false
        }
    }

    render() {

        return (
            <body data-sidebar="colored">
                <div id="layout-wrapper">
                    <Header />
                    <AppNavbar data={this.state}/>
                </div>
                <Dashboard/>
            </body>
        );
    }

    //Function to update state from userView
    onUpdate (data) { this.setState({ data }) }
}

export default Home;